import { fetchApi } from '@/config/axiosSetting';
import {
  GetVehicleInformationType,
  getVehicleInformationType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleInformation/getVehicleInformation.type';

export const getInitialVehicleInformationFunction = ({
  id,
}: getVehicleInformationType): Promise<GetVehicleInformationType> => {
  return fetchApi.get(`/initial/reports/${id}/vehicle_information/`);
};
